import React from "react";
import { Box, Typography } from "@mui/material";

interface CustomAlertProps {
  message: string;
  type: "success" | "error" | "info" | "warning";
}

const typeStyles = {
  success: { backgroundColor: "#4caf50", color: "white" },
  error: { backgroundColor: "#f44336", color: "white" },
  info: { backgroundColor: "#2196f3", color: "white" },
  warning: { backgroundColor: "#ff9800", color: "white" },
};

const CustomAlert: React.FC<CustomAlertProps> = ({ message, type }) => {

  const title: string = type === "success" ? "Sikeres" : type === "error" ? "Hiba" : type === "info" ? "Info" : "Figyelmeztetés";

  return (
    <Box
      sx={{
        ...typeStyles[type],
        padding: "16px",
        borderRadius: "8px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
        textAlign: "center",
        margin: "16px 0",
        width: "300px",
        position: "absolute",
        bottom: "0",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1000,
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        {title}
      </Typography>
      <Typography>{message}</Typography>
    </Box>
  );
};

export default CustomAlert;
